<div class="row   justify-content-start mb-2">
  <div class="col-12">
    <span class="iso-header ml-2">
      {{ "bikeshop.shop_setup.card_headers.pos_integration" | translate }}
    </span>
  </div>
</div>

<div class="content" *ngIf="showIntegrations">

  <div *ngIf="busy">
    <div>
      {{ "bikeshop.shop_profile.pos-integration.busy_message" | translate }}
    </div>
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                       strokeWidth="2"
                       fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div class="row" *ngIf="!busy">
    <div class="col-md-9">
      <div>
        <div class="row" *ngIf="posIntegration && posIntegration.ConnectedPOS">
          <div class="col-md-12">
            <div *ngIf="posIntegration.ConnectedPOS === 3">
              <app-vend-defaults [partner]="partner"></app-vend-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 6">
              <app-lightspeed-defaults [partner]="partner"></app-lightspeed-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 9">
              <app-shopify-defaults [partner]="partner"></app-shopify-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 10">
              <app-dear-defaults [partner]="partner"></app-dear-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 12">
              <app-retailexpress-defaults [partner]="partner"></app-retailexpress-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 13">
              <app-citruslime-defaults [partner]="partner"></app-citruslime-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 14">
              <app-eposnow-defaults [partner]="partner"></app-eposnow-defaults>
            </div>

            <div *ngIf="posIntegration.ConnectedPOS === 15">
              <app-eposnow-defaults [partner]="partner"></app-eposnow-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 16">
              <app-netsuite-defaults [partner]="partner"></app-netsuite-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 17">
              <app-square-defaults [partner]="partner"></app-square-defaults>
            </div>
             <div *ngIf="posIntegration.ConnectedPOS === 19">
              <app-heartlands-defaults [partner]="partner"></app-heartlands-defaults>
            </div>
            <div *ngIf="posIntegration.ConnectedPOS === 22">
              <app-ascend-defaults [partner]="partner"></app-ascend-defaults>
            </div>
            
            <div *ngIf="posIntegration.ConnectedPOS === 20">
              <app-teamwork-defaults [partner]="partner"></app-teamwork-defaults>
            </div>

          </div>
        </div>
      </div>

      <div class="sub-header margin-top-16">
        {{
        POSSystemID !== 8 ?
          ("bikeshop.shop_profile.pos-integration.pos_configuration" | translate) : ("bikeshop.shop_profile.pos-integration.accounting_platform" | translate)
        }}
      </div>

      <div>
        <div *ngIf="posIntegration && posIntegration.ConnectedPOS" class="pos-connected">
          <div class="row margin-top-8">
            <div *ngIf="orginizationName" class="col-md-4 label">
              {{ "bikeshop.shop_profile.xero-integration" | translate }}
              {{ orginizationName }}
            </div>
            <div *ngIf="!orginizationName" class="col-md-4 label">
              {{
              "bikeshop.shop_profile.pos-integration.connected_message"
                | translate
              }}:
            </div>
            <div class="col-md-2">
              <div class="pos-row">
                <div class="logo active"
                     [ngStyle]="{
                    'background-image': 'url(' + posIntegration.Image + ')'
                  }"></div>
              </div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="margin-top:auto;margin-bottom:auto;">
              <!-- Normal disconnect (no auth disconnect)-->
              <button *ngIf="posIntegration.ConnectedPOS != 19 && !orginizationName"
                      type="submit"
                      class="iso-round-button"
                      style="float:right"
                      (click)="disconnectPOS()"
                      [disabled]="busy || posIntegration.ConnectedPOS == 22">
                {{
                'bikeshop.shop_profile.pos-integration.button.disconnect_pos'
                  | translate
                }}
              </button>

              <!-- Disconnect with auth disconnect (heartlands) -->
              <button *ngIf="posIntegration.ConnectedPOS == 19 && !orginizationName"
                      type="submit"
                      class="iso-round-button"
                      style="float:right"
                      (click)="disconnectPOS_WithAuth()"
                      [disabled]="busy">
                {{
                'bikeshop.shop_profile.pos-integration.button.disconnect_pos'
                  | translate
                }}
              </button>

              <img src="../../../../../../../assets/pos/xero/disconnect-blue.svg"
                   alt="button"
                   (click)="disconnectPOS()"
                   class="pointer"
                   *ngIf="orginizationName" />
            </div>
          </div>
        </div>

        <div *ngIf="!posIntegration.ConnectedPOS" class="pos-connect">
          <div class="title margin-top-16 margin-bottom-16">
            {{
            "bikeshop.shop_profile.pos-integration.connect_message"
              | translate
            }}:
          </div>
          <!--<div class="row">
            <div class="col-md-12">
              <div class="pos-systems">
                <div *ngFor="let system of POSSytems">
                  <div class="logo"
                       [ngClass]="{ active: system.POSID === POSSystemID }"
                       [ngStyle]="{
                      'background-image': 'url(' + system.Image + ')'
                    }"
                       (click)="setPOSSystemID(system.POSID)"></div>
                </div>
              </div>
            </div>
          </div>-->


          <div class="row margin-top-32" >
            <div *ngFor="let system of POSSytems" class="col-12 col-sm-6 col-md-2 col-lg-2 mb-2 clickable-card"
                 (click)="setPOSSystemID(system.POSID)">
              <div class="platform-card">
                <div class="platform-logo">
                  <img [src]="system.Image" [alt]="system.Name" />
                </div>
                <div class="platform-details">
                  <h4 class="platform-name">{{system.Name}}</h4>
                  <!--<p class="platform-description">{{platform.description}}</p>-->
                  <!--<button pButton class="p-button-raised connect-button">
                    {{'messaging.connect' | translate}}
                  </button>-->
                </div>
              </div>
            </div>
          </div>

          <div class="pos-detail">
            *{{
            "bikeshop.shop_profile.pos-integration.connect_message_detail"
              | translate
            }}:
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3"></div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog key="pos_confirmation"></p-confirmDialog>
